import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

const Button = ({ wid, action, ...others }) => (
  <a
    className="btn btn--sml btn--grey draft-action"
    href={`/wires/${wid}${action === 'Edit' ? '/edit' : ''}`}
    {...others}
  >
    {action}
  </a>
);

Button.propTypes = {
  wid: PropTypes.number.isRequired,
  action: PropTypes.oneOf(['Edit', 'Preview', 'Delete']).isRequired,
};

export default function WireDraft({ wire }) {
  const slug = wire.slug || wire.id;
  const profile = window.Livewire?.currentUser?.profile;
  const currentUserId = window.Livewire?.currentUser?.id;
  const { userId, publishedAt } = wire;
  const isPublished = !!publishedAt;
  const isOwner = currentUserId && userId && currentUserId === userId;

  // Can edit if: editor can modify others' wires, OR owner can edit
  // (drafts always, published if permitted)
  const canEditWire = profile?.canModifyWiresOfOthers
    || (isOwner && (!isPublished || profile?.canEditPublishedWires));

  return (
    <div className="wire draft-wire">
      <h3 className="wire__title">
        <a href={`/wires/${slug}`}>{wire.title}</a>
      </h3>
      <span className="draft-status">
        {`Last saved on ${moment(wire.updatedAt).format('ddd Do MMMM @ h.mma')}`}
      </span>
      {canEditWire && <Button wid={slug} action="Edit" />}
      <Button wid={slug} action="Preview" />
      <Button
        wid={slug}
        action="Delete"
        data-method="delete"
        data-confirm="Are you sure you want to delete this draft?"
        rel="nofollow"
      />
    </div>
  );
}

WireDraft.propTypes = {
  wire: PropTypes.shape({
    id: PropTypes.number.isRequired,
    slug: PropTypes.string,
    title: PropTypes.string.isRequired,
    updatedAt: PropTypes.string.isRequired,
    userId: PropTypes.number,
    user_id: PropTypes.number,
    publishedAt: PropTypes.string,
    published_at: PropTypes.string,
  }).isRequired,
};
